// extracted by mini-css-extract-plugin
export var avatarContainer = "_42-1";
export var largeAvatarContainer = "_42-2";
export var smallAvatarContainer = "_42-0";